import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { EnvioActivoDTO, EnvioUltimaHoraDTO, IEnvioActivoDTO, IEnvioUltimaHoraDTO } from "@DTOS";
import { map } from "rxjs/operators";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class EstadisticasServiceBackend {

    constructor(private httpClient: HttpClient) {}

    public async getEnviosActivos(): Promise<EnvioActivoDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IEnvioActivoDTO[]>(
                `${Constants.apiURL}/stats/active_series`
            ).pipe(
                map(response => response.map(envioActivo => new EnvioActivoDTO(envioActivo)))
            )
        ) ?? [];
    }

    public async getEnviosEnLaUltimaHora(): Promise<EnvioUltimaHoraDTO[]> {
        return await firstValueFrom(
            this.httpClient.get<IEnvioUltimaHoraDTO[]>(
                `${Constants.apiURL}/stats/last_hour_answers`
            ).pipe(
                map(response => response.map(envioUltimaHora => new EnvioUltimaHoraDTO(envioUltimaHora)))
            )
        ) ?? [];
    }
}

